<template>
  <!-- How a task is answered: whether it is, with what, and from which options (US 9398) -->
  <div class="td-response">
    <div class="td-head">
      <h4>{{ title }}</h4>
      <span class="us-grow"></span>
      <TaskChoice :value="value.allow" :choices="allowChoices" :qid="qid + '-allow'" @input="set('allow', $event)"></TaskChoice>
    </div>

    <template v-if="value.allow !== 'No'">
      <div class="td-types" role="radiogroup">
        <button v-for="type in types"
                :key="type.value"
                type="button"
                role="radio"
                class="td-type"
                :class="{ 'is-on': value.type === type.value }"
                :aria-checked="value.type === type.value ? 'true' : 'false'"
                :qid="qid + '-type-' + type.key"
                @click="setType(type.value)"
        >
          <span class="td-type__icon"><font-awesome-icon :icon="type.icon"/></span>
          <span>
            <b>{{ $t('task_dialog.types.' + type.key + '.title') }}</b>
            <small>{{ $t('task_dialog.types.' + type.key + '.text') }}</small>
          </span>
        </button>
      </div>

      <template v-if="value.type === 'Dropdown'">
        <div v-if="canUseDefault" class="op-source__choices">
          <label class="op-source__option" :class="{ 'is-on': value.use_default }" :qid="qid + '-default'">
            <input type="radio" :name="qid + '-source'" :checked="value.use_default" @change="setUseDefault(true)">
            <span><b>{{ $t('dropdown_options.use_default') }}</b><small>{{ $t('dropdown_options.use_default_text') }}</small></span>
          </label>
          <label class="op-source__option" :class="{ 'is-on': !value.use_default }" :qid="qid + '-custom'">
            <input type="radio" :name="qid + '-source'" :checked="!value.use_default" @change="setUseDefault(false)">
            <span><b>{{ $t('dropdown_options.custom') }}</b><small>{{ $t('dropdown_options.custom_text') }}</small></span>
          </label>
        </div>
        <div v-if="canUseDefault && value.use_default" class="td-linked">
          <span class="td-linked__label"><font-awesome-icon icon="link"/>{{ $tc('task_dialog.linked_default', defaults.length, { count: defaults.length }) }}</span>
          <div class="op-pills">
            <OptionPill v-for="(option, index) in defaults" :key="index" :option="option"></OptionPill>
          </div>
        </div>
        <OptionListBuilder v-else
                           :value="value.options"
                           :presets="presets"
                           :copy-from="defaults.length ? defaults : null"
                           :copy-from-label="$t('task_dialog.copy_default')"
                           @input="set('options', $event)"
        ></OptionListBuilder>
      </template>

      <OptionListBuilder v-if="value.type === 'Yes/No'"
                         fixed
                         :value="value.yes_no"
                         @input="set('yes_no', $event)"
      ></OptionListBuilder>
    </template>
  </div>
</template>

<script>
  import TaskChoice from '@/components/assessment/TaskChoice.vue';
  import OptionPill from '@/components/assessment/OptionPill.vue';
  import OptionListBuilder from '@/components/assessment/OptionListBuilder.vue';

  export default {
    name: 'TaskResponseEditor',
    components: {
      TaskChoice,
      OptionPill,
      OptionListBuilder
    },
    props: {
      // { allow, type, options, use_default, yes_no }
      value: {
        type: Object,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      allowChoices: {
        type: Array,
        required: true
      },
      defaults: {
        type: Array,
        default: () => []
      },
      defaultOptions: {
        type: Boolean,
        default: false
      },
      presets: {
        type: Array,
        default: () => []
      },
      qid: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        types: [
          { key: 'dropdown', value: 'Dropdown', icon: 'list-ul' },
          { key: 'yes_no', value: 'Yes/No', icon: 'thumbs-up' },
          { key: 'date', value: 'Datepicker', icon: 'calendar-alt' }
        ]
      }
    },
    computed: {
      canUseDefault() {
        return this.defaultOptions && this.defaults.length > 0;
      }
    },
    methods: {
      set(key, value) {
        this.$emit('input', Object.assign({}, this.value, { [key]: value }));
      },
      setType(type) {
        this.set('type', type);
      },
      // A custom list starts as a copy of the default
      setUseDefault(on) {
        let changes = { use_default: on };
        if (!on && !this.value.options.length) {
          changes.options = this.defaults.map(option => Object.assign({}, option));
        }
        this.$emit('input', Object.assign({}, this.value, changes));
      }
    }
  }
</script>
